'use client';

import { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import { t } from '../../i18n';
import Icon from '../Icon';
// import PdfFullscreenViewer from '../../components/PdfFullscreenViewer/PdfFullscreenViewer';
import dynamic from 'next/dynamic';

const PdfFullscreenViewer = dynamic(
    () => import('../PdfFullscreenViewer/PdfFullscreenViewer.js'),
    { ssr: false }
);

import s from './DownloadFileItem.module.scss';

const DownloadFileItem = ({
    title,
    fileSize,
    buttonTitle,
    fileUrl,
    isLandscape,
}) => {
    if (!fileUrl) {
        return null;
    }

    const [isPdfViewerOpen, setIsPdfViewerOpen] = useState(false);
    const [pdfFile, setPdfFile] = useState(null);
    // const [pdfInitialPage, setPdfInitialPage] = useState(1);

    const getFileFormat = (url) => {
        const extension = url.split('.').pop();
        return extension ? extension.toUpperCase() : 'UNKNOWN';
    };

    const formatFileSize = (bytes) => {
        if (!bytes) return '';
        const mb = bytes / (1024 * 1024);
        if (mb >= 1) {
            return `${mb.toFixed(1)} MB`;
        }
        const kb = bytes / 1024;
        return `${Math.round(kb)} KB`;
    };

    const fileFormat = getFileFormat(fileUrl);
    const formattedSize = formatFileSize(fileSize);

    return (
        <div className={s.Root}>
            <PdfFullscreenViewer
                open={isPdfViewerOpen}
                file={pdfFile}
                isLandscape={isLandscape}
                onClose={() => setIsPdfViewerOpen(false)}
            />

            <div className={s.Container}>
                <div className={s.Content}>
                    <div className={s.IconWrapper}>
                        <Icon name="FileSave" />
                    </div>
                    <div className={s.Text}>
                        <p title={title} className={s.Title}>
                            {title}
                        </p>
                        <div className={s.Format}>
                            <span className={s.FileFormat}>{fileFormat}</span>
                            <span className={s.FileSize}>{formattedSize}</span>
                        </div>
                    </div>
                </div>
                <Button
                    title={
                        buttonTitle ??
                        t('downloadFileItem.relatedFiles', {
                            fileType:
                                fileFormat === 'UNKNOWN'
                                    ? ''
                                    : ` ${fileFormat}`,
                        })
                    }
                    modifier="Secondary"
                    isFullWidth
                    className={s.Button}
                    url={fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                />
                {fileFormat === 'PDF' && (
                    <Button
                        title={t('downloadFileItem.previewPdf')}
                        modifier="Secondary"
                        isFullWidth
                        className={s.Button}
                        onClick={() => {
                            setPdfFile(fileUrl);
                            // setPdfInitialPage(1);
                            setIsPdfViewerOpen(true);
                        }}
                    />
                )}
            </div>
        </div>
    );
};

DownloadFileItem.propTypes = {};

export default DownloadFileItem;
